module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_8019.e516ffc0.png";